import { readonly } from 'vue';
import { IActState, IActStore } from '@/models/act/store/state.interface';

import actState from './state';
import actGetters from './getters';
import actMutations from './mutations';

const actStore: IActStore = { actState: readonly(actState) as IActState, actMutations, actGetters };

export default actStore;
